module.exports = __webpack_public_path__ + "img/placeholder/typography-figure-1.jpg";